import { createSelector } from 'reselect';
import scheduleFacilityViewStateSelector from 'store/selectors/scheduleSelectors/scheduleFacilityViewStateSelector';

export const selectedLineScheduleRelayIdsSelector = createSelector(
  scheduleFacilityViewStateSelector,
  (lineSchedule) => {
    return lineSchedule.selectedLineScheduleRelayIds;
  },
);
